export default "/images/vendor/flag-icons/flags/1x1/sh-ta.svg?313be25910b1f22cc4e8540cf2c73541";